export const formEvent = 'form'
export const interactionFormEvent = 'interaction_form'
export const interactionQuestionEvent = 'interaction_question'
export const answerEvent = 'answer'
